import { render, staticRenderFns } from "./fapiao.vue?vue&type=template&id=66f55015&"
import script from "./fapiao.vue?vue&type=script&lang=js&"
export * from "./fapiao.vue?vue&type=script&lang=js&"
import style0 from "./fapiao.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports